import { createFileRoute } from "@tanstack/react-router"
import { OrganizationRolesPermissionsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/roles-permissions/"
)({
  component: () => (
    <AuthorizationGate resource={Resource.ROLE} action={Action.READ}>
      <OrganizationRolesPermissionsPage />
    </AuthorizationGate>
  ),
})
